import { createFileRoute } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";
import {
  buildOidcLoginUrlForPath,
  buildOidcLogoutUrl,
} from "@/lib/api/auth-redirect";

function ForbiddenPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <div className="max-w-md w-full space-y-4">
        <h1 className="text-2xl font-bold">Accès non autorisé</h1>
        <p className="text-muted-foreground">
          Votre compte CNCC ne dispose pas des droits requis pour utiliser
          SidonIAssist.
        </p>
        <p className="text-muted-foreground">
          Si vous pensez qu'il s'agit d'une erreur, contactez votre
          administrateur.
        </p>
        <div className="flex flex-wrap gap-2">
          <Button
            nativeButton={false}
            render={
              <a href={buildOidcLoginUrlForPath("/")}>Réessayer la connexion</a>
            }
          />
          <Button
            nativeButton={false}
            render={<a href={buildOidcLogoutUrl()}>Se déconnecter</a>}
          />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_public/forbidden")({
  component: ForbiddenPage,
});
